import { BotConversation } from "../../models/botConversation";

export const GET_CONVERSATIONS = "GET_CONVERSATIONS" as const;
export const GET_CONVERSATIONS_SUCCESS = "GET_CONVERSATIONS_SUCCESS" as const;
export const GET_CONVERSATIONS_FAILURE = "GET_CONVERSATIONS_FAILURE" as const;

export const getConversationsAction = () => ({
  type: GET_CONVERSATIONS,
});
export type GetConversationsAction = ReturnType<typeof getConversationsAction>;

export const getConversationsActionSuccess = (
  conversations: BotConversation[]
) => ({
  type: GET_CONVERSATIONS_SUCCESS,
  conversations: conversations,
});
export type GetConversationsActionSuccess = ReturnType<
  typeof getConversationsActionSuccess
>;

export const getConversationsActionFailure = () => ({
  type: GET_CONVERSATIONS_FAILURE,
});
export type GetConversationsActionFailure = ReturnType<
  typeof getConversationsActionFailure
>;
